import { request } from "../../utils/config"

export const GET_KPI_SETTING = async (params) => {
  const response = await request({
    url: `Helpers/KPI`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const UPDATE_KPI_SETTING = async (data) => {
    const response = await request({
      url: "Helpers/KPI",
      method: "PUT",
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    return response.data
  }